import gql from 'graphql-tag'
import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from '@components/error'
import ArticlesBlockEmbed from './articles-block-embed'

export const fragment = `
  articlesCollection {
    items {
      headline
      slug
      image {
        url
        description
      }
    }
  }
`

const QUERY = gql`
query RecommendedArticles($id: String!) {
  recommendedArticles(id: $id) {
    ${fragment}
  }
}
`

export default function ArticlesBlockEmbedWithData(props) {
  return (
    <Query query={QUERY} variables={props}>
      {({
        loading, error, data,
      }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data.recommendedArticles
        return (
          <ArticlesBlockEmbed {...response} />
        )
      }}
    </Query>
  )
}
